import styled, { css } from 'styled-components';
import media from '../../../styles/media';

export const OverviewContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 30px;
`;

export const Grid = styled.div`
  display: flex;
  flex: 1 1 auto;
  border: solid 1px ${props => props.theme.lightGray};
  min-height: 100%;
  margin-bottom: 15px;

  ${media.xl`
    margin-left: 15px;

    &:first-of-type {
        margin-left: 0;
        margin-right: 15px;
    }
  `};
`;

export const GridPanel = styled.div`
  width: 50%;

  ${props => props.right
    && `border-right: dashed 2px ${props.right ? props.theme.lightGray : props.theme.white}`};
`;

export const Word = styled.div`
  padding: 10px 15px;

  font-size: 0.875em;
  font-weight: 600;
  color: ${props => (props.personal
    ? props.theme.personal
    : props.partner
      ? props.theme.partner
      : props.theme.color)};

  background-color: ${props => (props.isHeader ? props.theme.lightGray : 'transparent')};
  position: relative;

  ${props => props.isHeader
    && css`
      &:after {
        content: '';
        width: 2px;
        height: 100%;
        position: absolute;
        top: 0;
        right: -2px;
        background: white;
      }
    `};
`;

export const Legenda = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);

  ${media.md`
  padding: 15px 0;
    display: flex;
    justify-content: space-around;
  `};

  .legenda-item {
    color: ${props => props.theme.color};
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
  }

  .legenda-color {
    width: 12px;
    height: 12px;
    border-radius: 100%;
    display: inline-block;
    margin-right: 10px;

    &--personal {
      background-color: ${props => props.theme.personal};
    }
    &--partner {
      background-color: ${props => props.theme.partner};
    }
  }
`;

export default OverviewContainer;
